// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_LedgerInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Query-string input for GET /ai/credits/admin/ledger.
 *
 * Optional:
 *   franquia_id (int|null)  — filter to one franchise
 *   limit       (int|null)  — max rows (server caps at 200)
 */
import { registerContract } from './validate'

export interface AiCredits_LedgerInput {
franquia_id?: number
limit?: number
}

registerContract('AiCredits_LedgerInput', {
  franquia_id: { type: 'number',  required: false },
  limit:       { type: 'number',  required: false },
})
